import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Laverage(props) {
  return (
    <div className="laverage_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Our Strategic Road Map for Your Mobile App Success</h2>
            <p>
              As a trusted app development company in San Francisco, we keep our
              approach flexible to provide personalized solutions that match
              your unique business needs. We understand that different
              businesses have specific organizational structures, so our app
              development strategy seamlessly blends with these operational
              processes, ensuring the development of a tailored app that fits
              perfectly.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={11} className="m-auto">
            <div className="process_listing">
              <div className="process_item">
                <div className="number">01</div>
                <h6>Ideation</h6>
                <p>
                  Conducting product research and defining the project scope
                </p>
              </div>
              <div className="process_item">
                <div className="number">02</div>
                <h6>Design</h6>
                <p>
                  Creating interactive UI/UX Design from a branding perspective
                </p>
              </div>
              <div className="process_item">
                <div className="number">03</div>
                <h6>Development</h6>
                <p>
                  Building the core functionality while incorporating rich
                  features
                </p>
              </div>
              <div className="process_item">
                <div className="number">04</div>
                <h6>Quality Assurance</h6>
                <p>
                  Ensuring optimal performance through rigorous testing and
                  validation
                </p>
              </div>
              <div className="process_item">
                <div className="number">05</div>
                <h6>Maintenance & Support</h6>
                <p>
                  Improvising app functionality or incorporating additional
                  features for scalability
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Laverage;
